export default __webpack_public_path__ + "static/media/bg4.13f5e8ae.jpg";